import { Card, Icon } from '@perch-labs/shrike';
import styled from 'styled-components';

export const HeaderContainer = styled.div`
  margin: 20px 0 24px 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const TextWrapper = styled.div`
  padding-top: 4px;
`;

export const BodyContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const InfoContainer = styled.div`
  color: #fff;
`;

export const UpdatedContent = styled(Card.Content)`
  padding: 4px 24px 24px 24px;
`;

export const InactiveContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 6px;
`;

export const IconContainer = styled(Icon)`
  height: 16px;
  width: 16px;
  margin-top: 6px;
`;
